import React from "react";
import { Box, Container, Button, useMediaQuery } from "@mui/material";
import bg from "../images/profit-bg.png";

function Footer() {
  const matches = useMediaQuery("(max-width:750px)");

  return (
    <Box
      pt={20}
      sx={{
        backgroundImage: `url(${bg})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        zIndex: 1,
      }}
      position="relative"
      top="-50px"
    >
      <Container maxWidth="lg">
        <Box
          display="flex"
          flexDirection={matches ? "column" : "row"}
          justifyContent="space-between"
          alignItems="center"
          mt={5}
        >
          <Box
            fontWeight={400}
            textAlign={matches ? "center" : "left"}
            fontSize={matches ? "18px" : "22px"}
          >
            All Rights Reserved © 2022 BNBShield
          </Box>
          <Box
            mt={matches ? 2 : 0}
            display="flex"
            justifyContent="center"
            flexDirection={matches ? "column" : "row"}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <a
                style={{
                  background:
                    "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 98%)",
                  borderRadius: "100px",
                  fontSize: "20px",
                  padding: "5px 11px",
                  marginRight: matches ? "6px" : "20px",
                  color: "#fff",
                }}
                href="https://t.me/bnbshield"
                target="_blank"
              >
                <i class="fab fa-telegram-plane"></i>
              </a>

              <a
                style={{
                  background:
                    "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 98%)",
                  borderRadius: "100px",
                  fontSize: "20px",
                  padding: "5px 10px",
                  marginRight: matches ? "6px" : "20px",
                  color: "#fff",
                }}
                href="https://twitter.com/bnbshieldcrypto"
                target="_blank"
              >
                <i class="fab fa-twitter"></i>
              </a>
              <a
                style={{
                  background:
                    "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 98%)",
                  borderRadius: "100px",
                  fontSize: "20px",
                  padding: "5px 10px",
                  marginRight: matches ? "6px" : "20px",
                  color: "#fff",
                }}
                href="https://www.reddit.com/user/Bnbshieldcrypto?utm_source=share&utm_medium=ios_app&utm_name=iossmf"
                target="_blank"
              >
                <i class="fab fa-reddit-alien"></i>
              </a>
              <a
                style={{
                  background:
                    "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 98%)",
                  borderRadius: "100px",
                  fontSize: "20px",
                  padding: "5px 10px",
                  marginRight: matches ? "6px" : "20px",
                  color: "#fff",
                }}
                href="#"
              >
                <i class="fab fa-medium-m"></i>
              </a>
            </Box>
            <Box mt={matches ? 2 : 0} display="flex" alignItems="center">
              <a
                style={{
                  cursor: "pointer",
                  width: matches ? "200px" : "150px",
                  textDecoration: "none",
                }}
                href="https://bscscan.com/address/0x98C8f021418D09D48d5021701B8e6886531967B9"
                target="_blank"
              >
                <Button
                  sx={{
                    // padding: "0px 30px",
                    width: matches ? "175px" : "150px",
                    height: "48.49px",
                    borderRadius: "37.54px",
                    border: "2px solid #EEBE62",
                    background:
                      "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 98%)",
                    textTransform: "capitalize",
                    color: "#FDFCFC",
                    fontSize: { xs: "12px", sm: "14px" },
                    fontWeight: 400,
                    backdropFilter: "blur(15.6406px)",
                    marginLeft: "10px",
                    position: "relative",
                    zIndex: 2,
                  }}
                >
                  Smart Contract
                </Button>
              </a>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
